import React from "react";

interface ThreeDotsLoadingSpinnerProps {
	className?: string;
	css?: string;
}

export default function ThreeDotsLoadingSpinner({
	className = "",
	css = "",
}: ThreeDotsLoadingSpinnerProps) {
	const svgProps = css
		? ({ css } as unknown as React.SVGProps<SVGSVGElement>)
		: {};

	return (
		<svg
			className={`if loader dots horizontal ${className}`}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 64 64"
			{...svgProps}
		>
			<title>Loading</title>
			<g className="if svg g">
				<circle className="if svg circle" fill="#331e11" cx={8} cy={32} r={8} />
				<circle
					className="if svg circle"
					fill="#331e11"
					cx={32}
					cy={32}
					r={8}
				/>
				<circle
					className="if svg circle"
					fill="#331e11"
					cx={56}
					cy={32}
					r={8}
				/>
			</g>
		</svg>
	);
}
